import { createContext, PropsWithChildren, useState } from 'react';

import { ThemeProviderProps } from '@totalenergiescode/react-components/themes';

export type ThemeChoice = ThemeProviderProps['appTheme'];

export interface ThemeContextShape {
  setThemePreference(preference: ThemeChoice): void;
  themePreference: ThemeChoice;
}

export const ThemeContext = createContext<ThemeContextShape>({
  setThemePreference: () => ({}),
  themePreference: 'dark',
});

export function ThemeContextProvider({ children }: PropsWithChildren) {
  const [themePreference, setThemePreference] = useState<ThemeChoice>('dark');

  return (
    <ThemeContext.Provider value={{ setThemePreference, themePreference }}>
      {children}
    </ThemeContext.Provider>
  );
}
